module.exports = __webpack_public_path__ + "u2f_ico@2x.2c816ef6fb7dc6a45144119bae854d17.png";